<template>
  <div>
    <div class="head-bg">
      <div class="head-title">
        <span>堆绿—做安全第一的绿色技术</span>
      </div>
      <div class="head-options">
        <div class="head-item">
          <img src="../../html/pages/showroom/image/ta1.png" alt />
          <p>案例云数据仓库</p>
        </div>
        <div class="head-item">
          <img src="../../html/pages/showroom/image/ta2.png" alt />
          <p>同行交流社区平台</p>
        </div>
        <div class="head-item">
          <img src="../../html/pages/showroom/image/ta3.png" alt />
          <p>线上/线下体验</p>
        </div>
        <div class="head-item">
          <img src="../../html/pages/showroom/image/ta4.png" alt />
          <p>一手行业资讯</p>
        </div>
        <div class="head-item">
          <img src="../../html/pages/showroom/image/ta5.png" alt />
          <p>水性产品线上展示</p>
        </div>
        <div class="head-item">
          <img src="../../html/pages/showroom/image/ta6.png" alt />
          <p>权威的系统施工方案</p>
        </div>
      </div>
    </div>

    <div class="main-bg">
      <div class="main-title lineH">
        <span>匠心记</span>
      </div>
      <div class="main-middle lineH">
        <img src="../../html/pages/showroom/image/lf.png" alt="">
        <span>一站式线上管理解决方案</span>
        <img src="../../html/pages/showroom/image/rt.png" alt="">
      </div>
      <div id="certify">
        <div class="swiper-bg">
          <img src="../../html/pages/showroom/image/m1.png" alt="">
        </div>
        <div class="swiper-container">
          <swiper
            :options="swiperOption"
            ref="mySwiper"
            class="swiper-wrapper"
            @progress="progress"
            @setTransition="setTransition"
          >
            <swiper-slide class="swiper-slide" v-for="(item,index) in currentImgList" :key="index">
              <img :src="item" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </div>

    <div class="foot-bg">
      <div class="foot-title lineH">
        <span>匠企行</span>
      </div>
      <div class="foot-middle">
        <span>现场经验分享</span>
        <span class="slanting-bar">/</span>
        <span>线下施工</span>
        <span class="slanting-bar">/</span>
        <span>线上体验</span>
      </div>
      <div class="foot-options">
        <div class="foot-item">
          <img src="../../html/pages/showroom/image/tc1.png" alt="">
          <p>同行成功案例分享</p>
        </div>
        <div class="foot-item">
          <img src="../../html/pages/showroom/image/tc2.png" alt="">
          <p>专业讲师、高资历专家授课</p>
        </div>
        <div class="foot-item">
          <img src="../../html/pages/showroom/image/tc3.png" alt="">
          <p>企业互联网化工具平台</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css'
import "../../html/pages/showroom/showroom.scss"

export default {
  name: 'showroom',
  data() {
    return {
      swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: true,
      },
      currentImgList: [
        require("../../html/pages/showroom/image/H1.jpg"),
        require("../../html/pages/showroom/image/H2.jpg"),
        require("../../html/pages/showroom/image/H3.jpg"),
        require("../../html/pages/showroom/image/H4.jpg"),
        require("../../html/pages/showroom/image/H5.jpg"),
      ],
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    progress(progress) {
      var modify, translate, scale, zIndex;
      for (var i = 0; i < this.swiper.slides.length; i++) {
        var slide = this.swiper.slides.eq(i);
        var slideProgress = this.swiper.slides[i].progress;
        modify = 1;
        if (Math.abs(slideProgress) > 1) {
          modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
        }
        translate = slideProgress * modify * 55 + 'px';
        scale = 1 - Math.abs(slideProgress) / 15;
        zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
        slide.css('zIndex', zIndex);
        slide.css('opacity', 1);
        if (Math.abs(slideProgress) > 3) {
          slide.css('opacity', 0);
        }
      }
    },
    setTransition(transition) {
      for (var i = 0; i < this.swiper.slides.length; i++) {
        var slide = this.swiper.slides.eq(i)
        slide.transition(transition);
      }
    }
  },
  mounted() {
  }

}
</script>

<style scoped>
</style>

